import * as sterlingparker from './PageButton.styles.sterlingparker';
import * as betprofessor from './PageButton.styles.betprofessor';
import * as puntgenie from './PageButton.styles.puntgenie';
import * as junglebet from './PageButton.styles.junglebet';
import * as volcanobet from './PageButton.styles.volcanobet';
import * as fiestabet from './PageButton.styles.fiestabet';
import * as puntcity from './PageButton.styles.puntcity';
import * as betgalaxy from './PageButton.styles.betgalaxy';
import * as betroyale from './PageButton.styles.betroyale';
import * as juicybet from './PageButton.styles.juicybet';
import * as goldenrush from './PageButton.styles.goldenrush';
import * as vikingbet from './PageButton.styles.vikingbet';
import * as questbet from './PageButton.styles.questbet';
import * as wellbet from './PageButton.styles.wellbet';
import * as sugarcastle from './PageButton.styles.sugarcastle';
import * as oldgill from './PageButton.styles.oldgill';
import * as buffalobet from './PageButton.styles.buffalobet';
import * as titanbet from './PageButton.styles.titanbet';
import * as gigabet from './PageButton.styles.gigabet';
import * as slambet from './PageButton.styles.slambet';
import * as betstride from './PageButton.styles.betstride';
import * as templebet from './PageButton.styles.templebet';
import * as goldenbet888 from './PageButton.styles.goldenbet888';
import * as hyperbet from './PageButton.styles.hyperbet';
import * as bet777 from './PageButton.styles.bet777';
import * as chromabet from './PageButton.styles.chromabet';
import * as bet575 from './PageButton.styles.bet575';
import * as epicodds from './PageButton.styles.epicodds';
import * as pyramidbet from './PageButton.styles.pyramidbet';
import * as magnumbet from './PageButton.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  betprofessor,
  puntgenie,
  junglebet,
  volcanobet,
  fiestabet,
  puntcity,
  betgalaxy,
  betroyale,
  juicybet,
  goldenrush,
  vikingbet,
  questbet,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
